import { Injectable } from '@angular/core';

export type CookieConsent = 'accepted' | 'rejected';

const CONSENT_STORAGE_KEY = 'wp-cookie-consent';
const ESSENTIAL_COOKIES: readonly string[] = ['csrfcookie'];

@Injectable({ providedIn: 'root' })
export class CookieService {
  public getCookie(name: string): string | null {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || null;
  }

  public getConsent(): CookieConsent | null {
    const value: string | null = localStorage.getItem(CONSENT_STORAGE_KEY);
    return value === 'accepted' || value === 'rejected' ? value : null;
  }

  public setConsent(consent: CookieConsent): void {
    localStorage.setItem(CONSENT_STORAGE_KEY, consent);
  }

  public clearNonEssentialCookies(): void {
    const cookies: string[] = document.cookie.split(';');
    for (const cookie of cookies) {
      const eqPos: number = cookie.indexOf('=');
      const name: string = (eqPos > -1 ? cookie.substring(0, eqPos) : cookie).trim();
      if (!name || ESSENTIAL_COOKIES.includes(name)) {
        continue;
      }
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    }
  }
}
